import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import ContactFormMenu from '@ep/components/ContactForm/ContactFormMenu';
import TextField from '@ep/components/TextField';
import { Subhead2 } from '@ep/components/Typography';
import theme from '@ep/theme';
// import { NotInterestedTwoTone } from '@mui/icons-material';
import React, { useState } from 'react';

interface formProps {
  type: string;
  data: object;
}
interface CardProps {
  setCardState: ({ header, icon, type, card }) => void;
  formState: formProps;
  setFormState: ({ type, data }) => void;
}

const CardContainer = styled.div`
  display grid;
  grid-template-columns: 1fr 4fr 1fr;
  grid-template-rows: 1fr 6fr 1fr;
  height: 100%;
`;

const Content = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-column: 2;
  grid-row: 2;
`;

const StyledSubhead = styled(Subhead2)`
  padding-right: 16rem;
  ${theme.mediaQueries.mobile} {
    padding: 1rem;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 5rem;
`;

const StyledTextField = styled(TextField)`
  grid-column: 2;
  margin-top: 0.25rem;
  .MuiFilledInput-input {
    height: 30px;
  }
  .MuiFilledInput-multiline {
    height: 70px;
    padding: 0rem 0rem;
    .MuiFilledInput-input {
      padding: 0rem 0rem;
      height: 70px;
    }
  }
  ${theme.mediaQueries.mobile} {
  }
`;

const StyledSubhead2 = styled(Subhead2)`
  max-width: 30rem;
`;

const Form = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0.5rem;
  @media (max-width: ${theme.breakpoints.optimalMobile + 400}px) {
    margin-top: 1.5rem;
    display: block;
  }
`;

const SICard2 = ({ setCardState, formState, setFormState }: CardProps) => {
  const menuOptions = [
    {
      label: 'Payroll Services',
      short: 'Payroll Services',
      value: 'Payroll Services',
    },
    {
      label:
        'SmartAccounting, SmartPO, SmartTime, SmartStart, CASHétPay, Production Portal',
      short: 'Production Finance Studio',
      value: 'Production Finance',
    },
    {
      label: 'Production Incentives',
      short: 'Production Incentives',
      value: 'Production Incentives',
    },
    {
      label: 'Movie Magic products',
      short: 'Movie Magic',
      value: 'Movie Magic',
    },
    {
      label: 'Digital Success Specialists',
      short: 'Digital Success Specialists',
      value: 'Digital Success Specialists',
    },
    {
      label:
        'Canada-specific products (Payroll, EP Live, EP On Location, EP Residency)',
      short: 'Canada',
      value: 'Canada specific',
    },
    {
      label: 'SyncOnSet and Scenechronize products',
      short: 'SyncOnSet, Scenechronize',
      value: 'SyncOnSet Scenechronize',
    },
    {
      label: 'AssetHub, SmartHub, or SmartHub Vault products',
      short: 'AssetHub, SmartHub/Vault',
      value: 'AssetHub SmartHub Vault',
    },
    {
      label: 'Other',
      short: 'Other',
      value: 'Other',
    },
  ];

  const [interest, setInterest] = useState('none');

  const highlightInterestField = () => {
    interest == 'none'
      ? (document.getElementById('salesInquiriesInterestMenu').style =
          'border: 3px solid ' + theme.colors.mediumRed)
      : (document.getElementById('salesInquiriesInterestMenu').style =
          'border: 1px solid ' + theme.colors.darkGray);
  };

  return (
    <CardContainer>
      <Content>
        <StyledSubhead>I'm interested in:*</StyledSubhead>
        <ContactFormMenu
          options={menuOptions}
          action={setInterest}
          menuId="salesInquiriesInterestMenu"
        />
        <StyledButton
          label="Continue"
          onClick={() => {
            if (interest != 'none') {
              setCardState({
                header: 'New Products, Services, and Incentives',
                icon: 'SalesInquiries',
                type: 'SICard',
                card: 3,
              });
              setFormState({
                ...formState,
                data: {
                  ...formState.data,
                  interest: interest,
                  // START SALESFORCE FIELDS
                  '00N1Y00000If2Cx': interest,
                  // END SALESFORCE FIELDS
                },
              });
            } else {
              highlightInterestField();
            }
          }}
        />
      </Content>
    </CardContainer>
  );
};

const SICard3 = ({ setCardState, formState, setFormState }: CardProps) => {
  interface InfoProps {
    firstName: string;
    lastName: string;
    'title-role': string;
    email: string;
    'state-country': string;
    productionTitle: string;
    productionCompany: string;
    memo: string;
  }

  const [infoData, setInfoData] = useState<InfoProps>({
    firstName: '',
    lastName: '',
    'title-role': '',
    email: '',
    'state-country': '',
    productionTitle: '',
    productionCompany: '',
    memo: '',
  });

  const [stateCountry, setStateCountry] = useState('none');

  const menuOptions = [
    {
      label: 'Canada',
      short: 'Canada',
      value: 'Canada',
    },
    {
      label: 'UK',
      short: 'UK',
      value: 'UK',
    },
    {
      label: 'International',
      short: 'International',
      value: 'International',
    },
    {
      label: 'Alabama',
      short: 'Alabama',
      value: 'Alabama',
    },
    {
      label: 'Alaska',
      short: 'Alaska',
      value: 'Alaska',
    },
    {
      label: 'Arizona',
      short: 'Arizona',
      value: 'Arizona',
    },
    {
      label: 'Arkansas',
      short: 'Arkansas',
      value: 'Arkansas',
    },
    {
      label: 'California',
      short: 'California',
      value: 'California',
    },
    {
      label: 'Colorado',
      short: 'Colorado',
      value: 'Colorado',
    },
    {
      label: 'Connecticut',
      short: 'Connecticut',
      value: 'Connecticut',
    },
    {
      label: 'Delaware',
      short: 'Delaware',
      value: 'Delaware',
    },
    {
      label: 'Florida',
      short: 'Florida',
      value: 'Florida',
    },
    {
      label: 'Georgia',
      short: 'Georgia',
      value: 'Georgia',
    },
    {
      label: 'Hawaii',
      short: 'Hawaii',
      value: 'Hawaii',
    },
    {
      label: 'Idaho',
      short: 'Idaho',
      value: 'Idaho',
    },
    {
      label: 'Illinois',
      short: 'Illinois',
      value: 'Illinois',
    },
    {
      label: 'Indiana',
      short: 'Indiana',
      value: 'Indiana',
    },
    {
      label: 'Iowa',
      short: 'Iowa',
      value: 'Iowa',
    },
    {
      label: 'Kansas',
      short: 'Kansas',
      value: 'Kansas',
    },
    {
      label: 'Kentucky',
      short: 'Kentucky',
      value: 'Kentucky',
    },
    {
      label: 'Louisiana',
      short: 'Louisiana',
      value: 'Louisiana',
    },
    {
      label: 'Maine',
      short: 'Maine',
      value: 'Maine',
    },
    {
      label: 'Maryland',
      short: 'Maryland',
      value: 'Maryland',
    },
    {
      label: 'Massachusetts',
      short: 'Massachusetts',
      value: 'Massachusetts',
    },
    {
      label: 'Michigan',
      short: 'Michigan',
      value: 'Michigan',
    },
    {
      label: 'Minnesota',
      short: 'Minnesota',
      value: 'Minnesota',
    },
    {
      label: 'Mississippi',
      short: 'Mississippi',
      value: 'Mississippi',
    },
    {
      label: 'Missouri',
      short: 'Missouri',
      value: 'Missouri',
    },
    {
      label: 'Montana',
      short: 'Montana',
      value: 'Montana',
    },
    {
      label: 'Nebraska',
      short: 'Nebraska',
      value: 'Nebraska',
    },
    {
      label: 'Nevada',
      short: 'Nevada',
      value: 'Nevada',
    },
    {
      label: 'New Hampshire',
      short: 'New Hampshire',
      value: 'New Hampshire',
    },
    {
      label: 'New Jersey',
      short: 'New Jersey',
      value: 'New Jersey',
    },
    {
      label: 'New Mexico',
      short: 'New Mexico',
      value: 'New Mexico',
    },
    {
      label: 'New York',
      short: 'New York',
      value: 'New York',
    },
    {
      label: 'North Carolina',
      short: 'North Carolina',
      value: 'North Carolina',
    },
    {
      label: 'North Dakota',
      short: 'North Dakota',
      value: 'North Dakota',
    },
    {
      label: 'Ohio',
      short: 'Ohio',
      value: 'Ohio',
    },
    {
      label: 'Oklahoma',
      short: 'Oklahoma',
      value: 'Oklahoma',
    },
    {
      label: 'Oregon',
      short: 'Oregon',
      value: 'Oregon',
    },
    {
      label: 'Pennsylvania',
      short: 'Pennsylvania',
      value: 'Pennsylvania',
    },
    {
      label: 'Rhode Island',
      short: 'Rhode Island',
      value: 'Rhode Island',
    },
    {
      label: 'South Carolina',
      short: 'South Carolina',
      value: 'South Carolina',
    },
    {
      label: 'South Dakota',
      short: 'South Dakota',
      value: 'South Dakota',
    },
    {
      label: 'Tennessee',
      short: 'Tennessee',
      value: 'Tennessee',
    },
    {
      label: 'Texas',
      short: 'Texas',
      value: 'Texas',
    },
    {
      label: 'Utah',
      short: 'Utah',
      value: 'Utah',
    },
    {
      label: 'Vermont',
      short: 'Vermont',
      value: 'Vermont',
    },
    {
      label: 'Virginia',
      short: 'Virginia',
      value: 'Virginia',
    },
    {
      label: 'Washington',
      short: 'Washington',
      value: 'Washington',
    },
    {
      label: 'West Virginia',
      short: 'West Virginia',
      value: 'West Virginia',
    },
    {
      label: 'Wisconsin',
      short: 'Wisconsin',
      value: 'Wisconsin',
    },
    {
      label: 'Wyoming',
      short: 'Wyoming',
      value: 'Wyoming',
    },
  ];

  const highlightField = fieldName => {
    if (fieldName != 'state-country') {
      !infoData[fieldName]
        ? (document.getElementsByName(fieldName)[0].style =
            'border: 3px solid ' + theme.colors.mediumRed)
        : (document.getElementsByName(fieldName)[0].style =
            'border: 0px solid white');
    } else {
      stateCountry === 'none'
        ? (document.getElementById('salesInquiriesLocationMenu').style =
            'border: 3px solid ' + theme.colors.mediumRed)
        : (document.getElementById('salesInquiriesLocationMenu').style =
            'border: 1px solid ' + theme.colors.darkGray);
    }
  };

  const highlightEmail = () => {
    document.getElementsByName('email')[0].style =
      'border: 3px solid ' + theme.colors.mediumRed;
  };

  const getFinalInterest = () => {
    const currentUrl =
      typeof window !== 'undefined' ? window.location.pathname : '';
    const currentPath = currentUrl.replace(/\//g, '');
    let preSetInterest = '';
    if (currentPath.includes('incentives') || currentPath.includes('tax')) {
      preSetInterest = 'Production Incentives';
    }
    const userSetInterest = formState.data.interest;
    return userSetInterest ? userSetInterest : preSetInterest;
  };

  const handleBlur = event => {
    const { name } = event.target;
    highlightField(name);
  };

  const handleChange = event => {
    const { name, value } = event.target;
    setInfoData({ ...infoData, [name]: value });
  };

  const handleSubmit = () => {
    const finalInterest = getFinalInterest();
    var email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (email.test(infoData.email)) {
      if (
        infoData.firstName &&
        infoData.lastName &&
        infoData['title-role'] &&
        infoData.email &&
        stateCountry != 'none' &&
        infoData.memo
      ) {
        setFormState({
          ...formState,
          data: {
            ...formState.data,
            // START SALESFORCE FIELDS
            debug: '0',
            debugEmail: 'mgalletti@ep.com',
            oid: '00Di0000000g6Hf',
            retURL: 'https://www.ep.com/thank-you/',
            interest: finalInterest,
            '00N1Y00000If2Cx': finalInterest,
            first_name: infoData.firstName,
            last_name: infoData.lastName,
            title: infoData['title-role'],
            email: infoData.email,
            '00N1Y00000IfGM3': stateCountry,
            '00Ni000000G38LY': infoData.productionTitle,
            company: infoData.productionCompany,
            description: infoData.memo,
            lead_source: 'Website Contact Us',
            // END SALESFORCE FIELDS
          },
        });
        setCardState({
          header: `Thank you`,
          icon: '',
          type: 'submitting',
          card: 1,
        });
      } else {
        highlightField('firstName');
        highlightField('lastName');
        highlightField('title-role');
        highlightField('state-country');
        highlightField('email');
        highlightField('memo');
      }
    } else {
      highlightEmail();
    }
  };

  return (
    <CardContainer>
      <Content>
        <Form>
          <Subhead2 style={{ gridColumn: 1 }}>First name:*</Subhead2>
          <StyledTextField
            name="firstName"
            value={infoData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Last name:*</Subhead2>
          <StyledTextField
            name="lastName"
            value={infoData.lastName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Title/role:*</Subhead2>
          <StyledTextField
            name="title-role"
            value={infoData['title-role']}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Email:*</Subhead2>
          <StyledTextField
            name="email"
            value={infoData.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <Subhead2 style={{ gridColumn: 1 }}>State/country:*</Subhead2>
          <ContactFormMenu
            options={menuOptions}
            action={setStateCountry}
            menuId="salesInquiriesLocationMenu"
          />
          <Subhead2 style={{ gridColumn: 1 }}>Production title:</Subhead2>
          <StyledTextField
            name="productionTitle"
            value={infoData.productionTitle}
            onChange={handleChange}
          />
          <Subhead2 style={{ gridColumn: 1 }}>Production company:</Subhead2>
          <StyledTextField
            name="productionCompany"
            value={infoData.productionCompany}
            onChange={handleChange}
          />
          <StyledSubhead2 style={{ gridColumn: 1 }}>
          <br/>Please provide your estimated Payroll budget details and any additional information regarding your production:*
          </StyledSubhead2>
          <StyledTextField
            multiline
            rows={3}
            name="memo"
            value={infoData.memo}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Form>

        <StyledButton label="Submit" onClick={handleSubmit} />
      </Content>
    </CardContainer>
  );
};

export { SICard2, SICard3 };
